import {Weather} from "../../widgets/weather";

export default function WeatherPage() {
    return <Weather/>
}